import styled from 'styled-components'

export const Avatar = styled.div`
  background: ${props => props.color};
  width: 45px;
  height: 45px;
  border-radius: 45px;
  border: 1px solid ${props => props.theme.border};
`
